import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Langs from "../../app/lang/langs";
import { checkPermission } from "../../app/utils/helpers";
import { NumberInput } from "../../components/inputs/NumberInput";
import { SelectInput } from "../../components/inputs/Select";
import { ThemeButton } from "../../components/buttons/ThemeButton";
import { config } from "../../app/utils/config.js";
import {
  getSettings,
  setLocalSettings,
  updateSettings,
  setSelectedCountry,
  setLanguage
} from "./settingsSlice";
import styles from "./Settings.module.css";

export default function GeneralSettingsTab() {

  const dispatch = useDispatch()

  const settings = useSelector((state) => state.settings)
  const localSettingsList = useSelector(
    (state) => state.settings.localSettingsList
  )

  const [lang, setLang] = useState(settings.lang)

  const languages = [
    { value: "en", label: "English" },
    { value: "fr", label: "Français" },
  ]

  const handleLanguageChange = (selectedOption) => {
    setLang(selectedOption.value)
    dispatch(setLanguage(selectedOption.value))
  }

  const handleParameterChange = (event) => {
    let changedParam = {
      value: event.target.value,
      id: event.target.id
    }
    dispatch(setLocalSettings(changedParam))
  }

  function handleSaveLocalSettings() {
    dispatch(updateSettings({
      fields: Object.values(localSettingsList).map(s => {
        console.log(s)
        let id = s.value
        let value = s.settingValue
        switch (s.type) {
          case "string":
            value = String(s.settingValue)
            break
          case "number":
            value = Number(s.settingValue)
            break
          default:
            break
        }
        return {
          id: id,
          value: value
        }
      }),
      id_country: settings.selectedCountry && settings.selectedCountry.value
    })).then(() => dispatch(getSettings()))
  }

  const handleCountryChange = (option) => {
    dispatch(setSelectedCountry(option))
  }

  let isEdit = checkPermission(config.scopes.settings, config.permissionTypes.edit)

  return (
    <div>
      <Row className="m-0">
        <Col xxl={1}>
        </Col>
        <Col xxl={8} className="d-flex align-content-center">
          <div className={styles.menuContent}>
            <Row><h3 className={styles.menuHeaderTitle + " p-2 ps-4"}>
              <Langs str="User settings" /></h3>
            </Row>
            <Row className="p-2">
              <Col
                md={6}
                className="d-flex justify-content-start align-items-center p-2 ps-4">
                <label className={styles.menuTitle}>
                  <Langs str="LANGUAGE" />
                </label>
              </Col>
              <Col md={6} className="p-2 m-0">
                <SelectInput
                  key={"lang_selector"}
                  value={lang}
                  onChange={handleLanguageChange}
                  options={languages} />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      {Object.values(localSettingsList).length && <Row className="m-0">
        <Col xxl={1}>
        </Col>
        <Col xxl={8} className="d-flex align-content-center">
          {isEdit && <div className={styles.menuContent + " mt-1"}>
            <Row>
              <Col xl={6}>
                <h3 className={styles.menuHeaderTitle + " p-2 ps-4"}>
                  <Langs str="Global settings" />
                </h3></Col>
              <Col
                xl={6}
                className="d-flex justify-content-end align-items-center p-2 pe-4">
                <label className="pe-2 fw-bold"><Langs str="country" /></label>
                <SelectInput
                  value={settings.selectedCountry && settings.selectedCountry.value}
                  onChange={handleCountryChange}
                  options={[{
                    value: null,
                    label: "Default",
                  }, ...settings.countries]
                  }
                />
              </Col>
            </Row>
            <Row className="p-2">
              {Object.values(localSettingsList).map((setting) => (
                <Row key={`ITEM_${setting.id}`}>
                  <Col
                    xl={9}
                    className="d-flex justify-content-start align-items-center p-2 ps-4">
                    <label className={styles.menuTitle}>
                      <Langs str={setting.label} />
                    </label>
                  </Col>
                  <Col
                    xl={3}
                    className="d-flex justify-content-end align-items-center p-2 m-0">
                    <NumberInput
                      name={setting.label}
                      min={setting.min || 0}
                      id={setting.id}
                      data-key={setting.value}
                      // disableKeyboard = {true}
                      max={setting.max || 999}
                      onChange={handleParameterChange}
                      value={setting.settingValue}
                    />
                  </Col>
                </Row>
              ))}
              <Row>
                <Col
                  xl={4}
                  className="d-flex justify-content-start align-items-center p-2 ps-4"
                ></Col>
                <Col
                  xl={4}
                  className="d-flex justify-content-center align-items-center p-2 m-0 mt-3">
                  <ThemeButton
                    title="SAVE"
                    active={true}
                    onClick={() => handleSaveLocalSettings()}
                  ></ThemeButton>
                </Col>
              </Row>
            </Row>
          </div>}
        </Col>
      </Row>
      }
    </div>
  )
}
